import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { CardTitle } from "../../components/antd/card/CardTitle";
import { BillingAccount } from "../../schema/types/account";
import { CpInput } from "../gvc/testNewForm/CpInput";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../gvc/testNewForm/CpErrorWarning";
import { FormItem } from "../../components/antd/form/FormItem";
import { FormLabel } from "../../components/antd/form/FormLabel";
import { FormItemValue } from "../../components/antd/form/FormItemValue";

interface Props {
  account: BillingAccount;
}
export const Summary: React.FC<Props> = ({ account }) => {
  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            <div className={`flex items-center`}>
              <div>Summary</div>
              <div className="flex-grow" />
            </div>
          </CardTitle>
          <CardContent>
            <div className="flex flex-wrap gap-x-32 gap-y-8 my-10">
              <FormItem lastItem>
                <FormLabel>Account ID</FormLabel>
                <FormItemValue>{account.id}</FormItemValue>
              </FormItem>
              <FormItem lastItem>
                <FormLabel>Email Address</FormLabel>
                <FormItemValue>{account.email || "-"}</FormItemValue>
              </FormItem>
            </div>
            {account.provider === "aws" ? (
              <>
                <div className="flex flex-wrap gap-x-32 gap-y-8 my-10">
                  <FormItem lastItem>
                    <FormLabel>Provider</FormLabel>
                    <FormItemValue>{account.provider}</FormItemValue>
                  </FormItem>
                  {account.providerId ? (
                    <FormItem lastItem>
                      <FormLabel>Provider ID</FormLabel>
                      <FormItemValue>{account.providerId || "-"}</FormItemValue>
                    </FormItem>
                  ) : null}
                  {Object.keys(account.providerData || {}).length > 0 ? (
                    <FormItem lastItem>
                      <FormLabel>Provider Data</FormLabel>
                      <div className="flex flex-col gap-1">
                        {Object.keys(account.providerData || {}).map((key) => (
                          <FormItemValue>
                            {key}: {JSON.stringify((account.providerData || {})[key])}
                          </FormItemValue>
                        ))}
                      </div>
                    </FormItem>
                  ) : null}
                </div>
              </>
            ) : null}
            <CpFormItem>
              <CpLabel name={`account.accountName`}>Account Name</CpLabel>
              <CpInput name={`account.accountName`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`account.accountName`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`account.fullName`}>Full Name</CpLabel>
              <CpInput name={`account.fullName`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`account.fullName`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`account.phone`}>Phone</CpLabel>
              <CpInput name={`account.phone`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`account.phone`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`account.company`}>Company</CpLabel>
              <CpInput name={`account.company`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`account.company`} />
            </CpFormItem>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
